import { type SearchHit, type SearchJumpItem } from './search.types';

export const SEARCH_CATALOG: readonly SearchHit[] = [
  {
    id: 'patient-margarethe',
    title: 'Margarethe Olsen',
    kind: 'patient',
    description: 'MRN 401922 · Hall Of Justice · Room 214',
  },
  {
    id: 'patient-ellis',
    title: 'Ellis Margolis',
    kind: 'patient',
    description: 'MRN 398777 · Hall Of Justice · Room 108',
  },
  {
    id: 'patient-tomas',
    title: 'Tomás Marquez',
    kind: 'patient',
    description: 'MRN 410033 · Hall Of Justice · Room 302',
  },
  {
    id: 'patient-maria',
    title: 'Maria Lopez',
    kind: 'patient',
    description: 'MRN 402118 · Hall Of Justice · Room 220',
  },
  {
    id: 'patient-gustavo',
    title: 'Gustavo Fuentes',
    kind: 'patient',
    description: 'MRN 399441 · Hall Of Justice · Room 116',
  },
  {
    id: 'patient-carlos',
    title: 'Carlos Rivera',
    kind: 'patient',
    description: 'MRN 405882 · Hall Of Justice · Room 331',
  },
  {
    id: 'patient-helen',
    title: 'Helen Cho',
    kind: 'patient',
    description: 'MRN 407210 · Hall Of Justice · Room 204',
  },
  {
    id: 'patient-david',
    title: 'David Okonkwo',
    kind: 'patient',
    description: 'MRN 408903 · Hall Of Justice · Room 118',
  },
  {
    id: 'document-prior-auth',
    title: 'Prior-auth — Margarethe Olsen',
    kind: 'document',
    description: 'PDF · updated 22 Aug',
  },
  {
    id: 'document-census',
    title: 'Census — August',
    kind: 'document',
    description: 'XLSX · updated 19 Aug',
  },
  {
    id: 'document-intake',
    title: 'Intake packet — Hall Of Justice',
    kind: 'document',
    description: 'PDF · updated 18 Aug',
  },
  {
    id: 'document-labs',
    title: 'Lab results — Ellis Margolis',
    kind: 'document',
    description: 'PDF · updated 15 Aug',
  },
  {
    id: 'document-discharge',
    title: 'Discharge summary — Tomás Marquez',
    kind: 'document',
    description: 'DOCX · updated 12 Aug',
  },
  {
    id: 'order-401187',
    title: 'Order #40-1187 — Margarethe Olsen',
    kind: 'order',
    description: 'Delivered 22 Aug · Hall Of Justice',
  },
  {
    id: 'order-387744',
    title: 'Order #38-7744 — Ellis Margolis',
    kind: 'order',
    description: 'Cancelled 11 Aug · Hall Of Justice',
  },
];

export const SEARCH_RECENT: readonly SearchHit[] = [
  SEARCH_CATALOG[0],
  SEARCH_CATALOG[8],
  { ...SEARCH_CATALOG[13], title: 'Order #40-1187' },
];

export const SEARCH_JUMP: readonly SearchJumpItem[] = [
  {
    id: 'jump-blockers',
    labelKey: 'header.search.jump.blockers',
    descriptionKey: 'header.search.jump.blockersMeta',
    icon: 'checkCircleFilled',
  },
  {
    id: 'jump-deliveries',
    labelKey: 'header.search.jump.deliveries',
    descriptionKey: 'header.search.jump.deliveriesMeta',
    icon: 'box',
  },
  {
    id: 'jump-add-patient',
    labelKey: 'header.search.jump.addPatient',
    descriptionKey: 'header.search.jump.addPatientMeta',
    icon: 'add',
  },
];

export function filterSearchHits(query: string): readonly SearchHit[] {
  const needle = query.trim().toLowerCase();
  if (!needle) return [];

  return SEARCH_CATALOG.filter((hit) => {
    const haystack = `${hit.title} ${hit.description ?? ''}`.toLowerCase();
    return haystack.includes(needle);
  });
}
